import i18next from "i18next";
import { getStorage } from "minimal-shared/utils";
import LanguageDetector from "i18next-browser-languagedetector";
import { I18nextProvider as Provider, initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";

import { fallbackLng } from "./locales-config";
import type { ReactNode } from "react";

// ----------------------------------------------------------------------

/**
 * [1] localStorage
 * Auto detection:
 * const lng = getStorage('i18nextLng')
 */
const lng = getStorage("i18nextLng", fallbackLng) as string;

void i18next
	.use(HttpBackend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		lng,
		fallbackLng,
		supportedLngs: ["en", "nl"],
		load: "languageOnly",
		debug: false,
		backend: {
			loadPath: "/i18n/locales/{{lng}}.json",
		},
		returnNull: false,
		returnEmptyString: false,
		returnObjects: false,
		interpolation: {
			escapeValue: false,
		},
	});

// ----------------------------------------------------------------------

type Props = {
	children: ReactNode;
};

export function I18nProvider({ children }: Props) {
	return <Provider i18n={i18next}>{children}</Provider>;
}
